import {addSlot,destroySlot,getDatas} from "../ads/googletag.ts"
import Icons from "../svg/Icons.ts";
import * as Html from "../util/Html.ts"

Html.registerWidget('widget/ads-adder',{init,destroy})

export function init(obj){
  var 
    dom = obj.get(0),
    slotType = dom.getAttribute('slot-type'),
    datas = getDatas(slotType),
    dim = datas?.dim;
  
    dom.style.background = "#F9F9F9 url(/images/ic_photo_48dp.svg) no-repeat 50%";
    dom.style.backgroundSize = "48px";
  
  if(dim){
    dom.style.position = 'relative' 
    dom.innerHTML = `<icon data-fw-onclick="takepremiumfromads" style="position:absolute;border:none;right:16px;top:16px;border-radius:16px;padding:2px;font-size:20px;color:white;background-color:#80808080;">${Icons.ic_close}</icon>
    <div id="${datas.id}" style="min-width: ${dim[0]}px; min-height: ${dim[1]}px;"></div>`;
    addSlot(slotType)
  } else{
    console.log('Config error for slot-type '+slotType)
  } 
}
export function destroy(obj){
  var 
    dom = obj.get(0),
    slotType = dom.getAttribute('slot-type');
  destroySlot(slotType)

}
//setTimeout((Html.trigger(null,'takepremiumfromads')))